<template>
	<div class="car-add">

		<div style="width:75%;border:1px solid #DCDFE6;border-radius: 5PX;padding-right: 15px;margin-bottom: 15px;">
			<div class="headCarAdd">
				<i class="el-icon-setting"></i>&nbsp;&nbsp;表单录入
			</div>
			<div class="car-add-form-container">
				<el-form label-width="120px" ref="addCarForm" :model="addCarForm" :rules="addCarFormRules">
					<el-row>
						<el-col :span="12">
							<el-form-item label="机器人名称" prop="carName">
								<el-input placeholder="请输入机器人名称" v-model="addCarForm.carName"
									@input="e => addCarForm.carName = e.replace(/[^\w\u4e00-\u9fa5-_]+$/g,'')">
								</el-input>
							</el-form-item>
						</el-col>
						
					</el-row>

					<el-row>
						<!-- <el-col :span="12">
							<el-form-item label="设备类型" prop="deviceType">
								<el-select style="width:100%" placeholder="请选择设备类型" v-model="addCarForm.deviceType">
									<el-option v-for="(item,index) in typeOptions" :key="index" :label="item"
										:value="index"></el-option>
								</el-select>
							</el-form-item>
						</el-col> 
						</el-col> -->
						<el-col :span="12">
							<el-form-item label="运营单位" prop="entityId">
								<el-select style="width:100%" placeholder="请选择运营单位" v-model="addCarForm.entityId">
									<el-option v-for="item in entityInfoOptions" :key="item.value" :label="item.label"
										:value="item.value"></el-option>
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="机器人图片">
								<el-input v-model="addCarForm.img" maxlength="255"></el-input>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="12">
							<el-form-item label="机器人类型" prop="carType">
								<el-select  style="width:100%" placeholder="请选择机器人类型" v-model="addCarForm.carType" 
									@change="selectCarTypeName(addCarForm.carType)">
								  <el-option v-for="item in carTypeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
								</el-select>
						  </el-form-item>   
						</el-col>
						<el-col :span="12">
							<el-form-item label="机器人型号" prop="carModel">
								<el-select style="width:100%" :placeholder="addCarForm.carType==''?'请选择机器人类型':'请选择机器人型号'"
									v-model="addCarForm.carModel">
									<el-option v-for="item in selectedCarTypes" :key="item.value" :label="item.label"	:value="item.value"></el-option>
								</el-select>
							</el-form-item>
						</el-col>
					</el-row>


					<el-row>
						<el-col :span="12">
							<el-form-item label="WIFI名称" prop="wifiName">
								<el-input v-model="addCarForm.wifiName" maxlength="100"
									@input="e => addCarForm.wifiName = e.replace(/[^\w\u4e00-\u9fa5]+$/g,'')">
								</el-input>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="WIFI密码" prop="wifiPassword">
								<el-input v-model="addCarForm.wifiPassword" maxlength="20"
									@input="e => addCarForm.wifiPassword = e.replace(/[^\w\u4e00-\u9fa5]+$/g,'')">
								</el-input>
							</el-form-item>
						</el-col>
					</el-row>
					

					<el-row>
						<el-col :span="12" style="text-align: center;">
							<el-button type="primary" @click="addCar()">添加机器人</el-button>
						</el-col>
						<el-col :span="12" tyle="text-align: center;">
							<el-button type="primary" @click="clearAddCarForm()">清空表单</el-button>
						</el-col>
					</el-row>
				</el-form>
			</div>
		</div>

		<!-- <div style="width:75%;border:1px solid #DCDFE6;border-radius: 5PX;padding-right: 15px;margin-bottom: 15px;">
			<div class="headCarAdd">
				<i class="el-icon-setting"></i>&nbsp;&nbsp;批量录入
			</div>
			<div class="filter-container" style="padding-top: 15px;">
				<label class="control-label">输入数量：</label>
				<el-input placeholder="请输入数量(0-100)" v-model="carNum" style="width: 200px;float:left"
					class="filter-item" @input="e => carNum = e.replace(/[^\d]/g,'')"></el-input>
				<el-select v-model="carTypeOption" style="width: 120px;float: left;" class="filter-item">
					<el-option v-for="(item, index) in typeOptions" :key="index" :value="item">
					</el-option>
				</el-select>
				<el-button class="filter-item" type="primary" icon="el-icon-download"
					style="margin-left: 10px;float:left" @click="carDownloadBtn">
					车辆信息模板文件下载
				</el-button>
				文件上传区
				<el-upload :multiple="false" class="upload-demo" ref="upload" name="mfile" :action="url"
					:headers="uploadHeaders" :data="uploadData" :on-preview="handlePreview" :on-remove="handleRemove"
					:before-remove="beforeRemove" :limit="1" :on-success="successUpload" :on-error="errorUpload"
					accept=".xls" :file-list="file_list" :auto-upload="false">
					<el-button slot="trigger" type="warning">选择文件</el-button>
					<el-button style="margin-left: 10px;" type="success" @click="submitUpload">上传</el-button>
				</el-upload>
			</div> -->


		</div>

		<!--<div class="portlet-body flip-scroll" style="padding-bottom:50px;">-->
		<!-- justify-content: center;主轴居中     align-items: center;"侧轴居中 -->
		<!-- <el-row :gutter="20" style="display: flex;align-items: center;">
        <el-col :span="1.5">
          <div class="grid-content bg-purple;">
            <label>添加车辆:</label>
          </div>
        </el-col>
        <el-col :span="5" style="padding-left:0px;">
          <div class="grid-content bg-purple"> -->
		<!-- 文件上传区 -->
		<!-- <el-upload :multiple="false" class="upload-demo" ref="upload" name="mfile" :action="url"
              :headers="uploadHeaders" :data="uploadData" :on-preview="handlePreview" :on-remove="handleRemove"
              :before-remove="beforeRemove" :limit="1" :on-success="successUpload" :on-error="errorUpload" accept=".xls"
              :file-list="file_list" :auto-upload="false">
              <el-button slot="trigger" type="warning">选择文件</el-button>
              <el-button style="margin-left: 10px;" type="success" @click="submitUpload">上传</el-button>
            </el-upload>
          </div>
        </el-col>
        <el-col :span="15">
          <div class="grid-content bg-purple"></div>
        </el-col>
      </el-row>
    </div> -->

	</div>
</template>

<script>
	import {
		download,
		getNotRepeatingCarTypes,
		getTypesByCarTypeName,
		addCar
	} from '@/api/car'

	export default {
		name: 'CarAdd',
		data() {
			return {
				//添加车辆表单数量
				addCarForm: {
					carName: '', //车辆名称
					entityId: '', //所属运营单位
					deviceType: '0', //设备类型
					carType: '', //车辆类型 —— 名称
					carModel: '', //车辆型号 —— 类型id
					img:'http://admin.techinao.com:8615/picserve/s142.png',
					wifiName:'ReboNeoS142',
					wifiPassword:'12345678'
				},
				addCarFormRules: {
					carName: [{
						required: true,
						message: '请输入机器人名称',
						trigger: 'blur'
					}],
					entityId: [{
						required: true,
						message: '请选择所属单位',
						trigger: 'change'
					}],
					// carType: [{
					// 	required: true,
					// 	message: '请选择设备类型',
					// 	trigger: 'change'
					// }],
					deviceType: [{
						required: true,
						message: '请选择机器人类型',
						trigger: 'change'
					}],
					carModel: [{
						required: true,
						message: '请选择机器人型号',
						trigger: 'change'
					}],
				},
				entityInfoOptions: [], //运营单位信息列表
				carTypeOptions: [], //车辆类型
				selectedCarTypes: [], //车辆型号

				carNum: '',
				carTypeOption: '真车',
				typeOptions: [
					'真车',
					'模拟车',
					'carla'
				],
				//文件上传
				file_list: [],
				uploadHeaders: {
					authorization: this.$store.state.user.authorization
				},
				uploadData: {
					command_id: 38,
				},
				url: process.env.VUE_APP_BASE_API + '/car/add_car_csv'
			}
		},
		methods: {
			//初始化页面数据
			initPage() {
				// 初始化运营商信息
				if (this.entityInfoOptions.length === 0) {
					let entitys = JSON.parse(localStorage.entity)
					for (let k in entitys) {
						this.entityInfoOptions.push({
							value: k,
							label: entitys[k]
						})
					}
				}

				//初始化车辆类型
				getNotRepeatingCarTypes(this.$store.getters['user/entityId']).then(res => {
					if (res.result == '200') {
						this.carTypeOptions = res.data.map((item, index) => {
							return {
								value: item.name,
								label: item.name
							}
						})
					} else {
						this.$message.error(res.message)
					}
				})
			},
			//级联查询型号
			selectCarTypeName(carTypeName) {
				this.addCarForm.carModel = '';
				//获取指定车辆类型名称下，所有的车辆型号
				getTypesByCarTypeName(this.$store.getters['user/entityId'], carTypeName).then(res => {
					if (res.result == '200') {
						// this.selectedCarTypes = res.data;
						this.selectedCarTypes = res.data.map((item, index) => {
							return {
								value: item.id,
								label: item.name,
							}
						})
					} else {
						this.$message.error(res.message)
					}
				})
			},
			/**
			 * 添加车辆
			 */
			addCar() {
				this.$refs.addCarForm.validate((valid) => {
					if (!valid) {
						this.$message({
							type: 'info',
							message: '请检查输入'
						})
					} else {
						console.log(this.addCarForm)
						addCar(this.addCarForm).then(res => {
							if (res.result == '2') {
								this.$message({
									type: 'success',
									message: res.message

								})
							} else {
								this.$message({
									type: 'error',
									message: res.message
								})
							}
						})
					}
				})
			},
			//清空车辆信息
			clearAddCarForm() {
				this.$refs.addCarForm.resetFields();
			},
			// 文件提交之前的操作 可以进行type类型的判断
			onBeforeUploadImage(file) {
				console.log(file)
			},
			// 文件提交
			UploadImage(param) {
				const formData = new FormData()
				formData.append('ModelName', param.file) // 要提交给后台的文件
				formData.append('projectFolder', this.routeProjectId) // 这个接口必要的项目id
				formData.append('subFolder', this.routeFloorId) // 这个接口必要的其他的id
				/* UploadFiles(formData).then(response => { // UploadFiles 是封装的接口
				  if (response !== undefined) {
				    Message({
				      message: response.Msg,
				      type: 'success',
				      duration: 5 * 1000
				    })
				    param.onSuccess()
				    this.$store.state.basics.ShuxinTable = true
				  }
				}) */
			},


			/**
			 * 监听下载按钮点击事件
			 */
			carDownloadBtn() {
				let carTypeNum = '';
				if ("真车" === this.carTypeOption) {
					carTypeNum = 0;
				} else if ("carla" === this.carTypeOption) {
					carTypeNum = 2;
				}
				if (this.carNum == "") {
					this.$message.error("请输入1-100的正整数");
					return;
				}
				if (parseInt(this.carNum) < 1 || parseInt(this.carNum) > 100) {
					this.$message.error("请输入1-100的正整数");
				} else {
					alert("添加" + this.carNum + "辆车");
					download(this.carNum, carTypeNum).then(res => {
						let excelName = this.getNowDate();
						this.carDownload(res, "机器人信息表_" + excelName + ".xls");
					});
				}
			},
			// 下载文件
			carDownload(data, fileName) {
				if (!data) {
					return
				}
				let url = window.URL.createObjectURL(new Blob([data]))
				let link = document.createElement('a')
				link.style.display = 'none'
				link.href = url
				link.setAttribute('download', fileName)

				document.body.appendChild(link)
				link.click()
				// window.URL.removeObjectURL(link.href)
				document.body.removeChild(link)
			},
			/**
			 * 获取当前日期
			 */
			getNowDate() {
				let date = new Date();
				return this.dateFormat("YYYYmmdd_HHMMSS", date);
			},
			/**
			 * 日期格式化
			 * @param {Object} fmt 
			 * @param {Object} date
			 */
			dateFormat(fmt, date) {
				let ret;
				date = new Date(date);
				const opt = {
					"Y+": date.getFullYear().toString(), // 年
					"m+": (date.getMonth() + 1).toString(), // 月
					"d+": date.getDate().toString(), // 日
					"H+": date.getHours().toString(), // 时
					"M+": date.getMinutes().toString(), // 分
					"S+": date.getSeconds().toString() // 秒
					// 有其他格式化字符需求可以继续添加，必须转化成字符串
				};
				for (let k in opt) {
					ret = new RegExp("(" + k + ")").exec(fmt);
					if (ret) {
						fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
					};
				};
				return fmt;
			},
			/**
			 * 上传文件处理
			 */
			handleRemove(file, fileList) {
				console.log(file, fileList);
			},
			handlePreview(file) {
				console.log(file);
			},
			beforeRemove(file, fileList) {
				return this.$confirm(`确定移除 ${ file.name }？`);
			},
			/**
			 * 上传成功
			 * @param {Object} res
			 * @param {Object} file
			 * @param {Object} fileList
			 */
			successUpload(res, file, fileList) {
				if (res.result === "0") {
					this.$message({
						message: '上传成功',
						type: 'success'
					})
					this.$router.push({
						name: 'car_manage',
					});
				} else {
					this.$message.error(res.message);
				}
			},
			/**
			 * 上传发生错误
			 * @param {Object} err
			 * @param {Object} file
			 * @param {Object} fileList
			 */
			errorUpload(err, file, fileList) {
				this.$message.error('上传失败' + err.message);
			},
			/**
			 * 提交上传文件
			 */
			submitUpload() {
				this.$refs.upload.submit();
			},

		},
		mounted() {
			this.initPage()
		}
	}
</script>

<style>
	.headCarAdd {
		width: 100%;
		height: 50px;
		color: #000000;
		line-height: 50px;
		padding-left: 15px;
		border-bottom: 1px solid #DCDFE6;
	}

	.car-add-form-container {
		margin-top: 15px;
		margin-bottom: 15px;
		font-size: 30px;
	}

	.control-label {
		width: 120px;
		text-align: right;
		vertical-align: middle;
		float: left;
		font-size: 14px;
		color: #606266;
		line-height: 40px;
		padding: 0 12px 0 0;
		box-sizing: border-box;
	}

	/* el-upload组件中的.upload-demo div 为行级块，将其调整为行内块 */
	.upload-demo {
		display: inline-block;
		margin-left: 15px;
	}
</style>
